<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border="inner"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="data"
      :columns="columns"
      :height="800"
      row-id="userCode"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :row-class-name="({ row }) => (row.selected ? 'row--current' : '')"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #opt="{ row }">
        <i
          v-if="!row.selected"
          class="el-icon-check tool-btn"
          @click="$emit('select', row)"
        />

        <i
          v-else
          class="el-icon-close tool-btn text-danger"
          @click="$emit('remove', row)"
        />
      </template>

      <template #empty>
        <div class="text-center">
          <img src="/image/static/img/nodata.png" />
          <p class="m-0 mt-2">
            {{ $l('INDEX.table_label_empty') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import lodash from 'lodash'
import TableColumns from './table-columns'
export default {
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    selectedIds: { type: Array, default: () => [] },
  },
  computed: {
    columns() {
      return TableColumns(this)
    },
    data() {
      return lodash.map(this.tableData, (item) => ({
        ...item,
        selected: lodash.includes(this.selectedIds, item.userCode),
      }))
    },
  },
}
</script>

<style lang="scss" scoped></style>
